import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
  ReferenceField,
  NumberField,
} from 'react-admin';

export const CharacteristicShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="slug" />
      <TextField source="unit" />
      <TextField source="description" />
      
      <ReferenceField source="groupId" reference="characteristic-groups" link="show">
        <TextField source="name" />
      </ReferenceField>
      
      <NumberField source="sortOrder" />
      <BooleanField source="isActive" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
